export default "__VITE_ASSET__Bat0zN7q__"